import { render, staticRenderFns } from "./PrintModeColorSelect.vue?vue&type=template&id=8320389e&scoped=true&"
import script from "./PrintModeColorSelect.vue?vue&type=script&lang=js&"
export * from "./PrintModeColorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8320389e",
  null
  
)

export default component.exports